import { useState, useCallback } from 'react';
import { presignHallazgoImagenUpload, confirmHallazgoImagen } from 'api/hallazgoImagenes';

export function useHallazgoImagenUpload() {
  const [loading, setLoading] = useState(false);

  const upload = useCallback(async (idHallazgo, file) => {
    if (!idHallazgo) throw new Error('useHallazgoImagenUpload: idHallazgo requerido');
    if (!file) throw new Error('useHallazgoImagenUpload: file requerido');
    setLoading(true);
    try {
      const contentType = file.type;
      const { uploadUrl, key } = await presignHallazgoImagenUpload(idHallazgo, contentType);
      const putRes = await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': contentType },
        body: file,
      });
      if (!putRes.ok) throw new Error(`S3 PUT failed: ${putRes.status}`);
      return await confirmHallazgoImagen(idHallazgo, key);
    } finally {
      setLoading(false);
    }
  }, []);

  return { upload, loading };
}
